/*
	By André Rinas, www.andrerinas.de
	Documentation, www.simplelightbox.de
	Available for use under the MIT License
	1.17.3
*/
!function(st,ot,E){"use strict";st.fn.simpleLightbox=function(N){N=st.extend({sourceAttr:"href",overlay:!0,spinner:!0,nav:!0,navText:["&lsaquo;","&rsaquo;"],captions:!0,captionDelay:0,captionSelector:"img",captionType:"attr",captionsData:"title",captionPosition:"bottom",captionClass:"",close:!0,closeText:"&times;",swipeClose:!0,showCounter:!0,fileExt:"png|jpg|jpeg|gif|webp",animationSlide:!0,animationSpeed:250,preloading:!0,enableKeyboard:!0,loop:!0,rel:!1,docClose:!0,swipeTolerance:50,className:"simple-lightbox",widthRatio:.8,heightRatio:.9,scaleImageToRatio:!1,disableRightClick:!1,disableScroll:!0,alertError:!0,alertErrorMessage:"Image not found, next image will be loaded",additionalHtml:!1,history:!0,throttleInterval:0,doubleTapZoom:2,maxZoom:10,htmlClass:"has-lightbox"},N);function P(){return o.hash.substring(1)}function p(){P();var t="pid="+(V+1),e=o.href.split("#")[0]+"#"+t;s?history[f?"replaceState":"pushState"]("",E.title,e):f?o.replace(e):o.hash=t,f=!0}function t(e,a){var n;return function(){var t=arguments;n||(e.apply(this,t),n=!0,setTimeout(function(){return n=!1},a))}}function a(t){t.trigger(st.Event("show.simplelightbox")),N.disableScroll&&(u=T("hide")),N.htmlClass&&""!=N.htmlClass&&st("html").addClass(N.htmlClass),b.appendTo("body"),_.appendTo(b),N.overlay&&l.appendTo(st("body")),m=!0,V=$.index(t),K=st("<img/>").hide().attr("src",t.attr(N.sourceAttr)).attr("data-scale",1).attr("data-translate-x",0).attr("data-translate-y",0),-1==d.indexOf(t.attr(N.sourceAttr))&&d.push(t.attr(N.sourceAttr)),_.html("").attr("style",""),K.appendTo(_),C(),l.fadeIn("fast"),st(".sl-close").fadeIn("fast"),g.show(),J.fadeIn("fast"),st(".sl-wrapper .sl-counter .sl-current").text(V+1),c.fadeIn("fast"),tt(),N.preloading&&w(),setTimeout(function(){t.trigger(st.Event("shown.simplelightbox"))},N.animationSpeed)}function Z(t,e,a){return t<e?e:a<t?a:t}function z(t,e,a){K.data("scale",t),K.data("translate-x",e),K.data("translate-y",a)}var h,e,H="ontouchstart"in ot,L=(ot.navigator.pointerEnabled||ot.navigator.msPointerEnabled,0),j=0,K=st(),i=function(){var t=E.body||E.documentElement;return""===(t=t.style).WebkitTransition?"-webkit-":""===t.MozTransition?"-moz-":""===t.OTransition?"-o-":""===t.transition&&""},U=!1,d=[],$=N.rel&&!1!==N.rel?(e=N.rel,st(this).filter(function(){return st(this).attr("rel")===e})):this,n=$.get()[0].tagName,u=(i=i(),0),B=!1!==i,s="pushState"in history,f=!1,o=ot.location,Q=P(),G="simplelb",l=st("<div>").addClass("sl-overlay"),r=st("<button>").addClass("sl-close").html(N.closeText),g=st("<div>").addClass("sl-spinner").html("<div></div>"),J=st("<div>").addClass("sl-navigation").html('<button class="sl-prev">'+N.navText[0]+'</button><button class="sl-next">'+N.navText[1]+"</button>"),c=st("<div>").addClass("sl-counter").html('<span class="sl-current"></span>/<span class="sl-total"></span>'),m=!1,V=0,v=0,x=st("<div>").addClass("sl-caption "+N.captionClass+" pos-"+N.captionPosition),_=st("<div>").addClass("sl-image"),b=st("<div>").addClass("sl-wrapper").addClass(N.className),tt=function(o){if(K.length){var l=new Image,r=ot.innerWidth*N.widthRatio,c=ot.innerHeight*N.heightRatio;l.src=K.attr("src"),K.data("scale",1),K.data("translate-x",0),K.data("translate-y",0),at(0,0,1),st(l).on("error",function(t){$.eq(V).trigger(st.Event("error.simplelightbox")),U=!(m=!1),g.hide();var e=1==o||-1==o;v===V&&e?it():(N.alertError&&alert(N.alertErrorMessage),nt(e?o:1))}),l.onload=function(){void 0!==o&&$.eq(V).trigger(st.Event("changed.simplelightbox")).trigger(st.Event((1===o?"nextDone":"prevDone")+".simplelightbox")),N.history&&(f?h=setTimeout(p,800):p()),-1==d.indexOf(K.attr("src"))&&d.push(K.attr("src"));var t=l.width,e=l.height;if(N.scaleImageToRatio||r<t||c<e){var a=r/c<t/e?t/r:e/c;t/=a,e/=a}st(".sl-image").css({top:(ot.innerHeight-e)/2+"px",left:(ot.innerWidth-t-u)/2+"px",width:t+"px",height:e+"px"}),g.hide(),K.fadeIn("fast"),U=!0;var n,i="self"==N.captionSelector?$.eq(V):$.eq(V).find(N.captionSelector);if(n="data"==N.captionType?i.data(N.captionsData):"text"==N.captionType?i.html():i.prop(N.captionsData),N.loop||(0===V&&st(".sl-prev").hide(),V>=$.length-1&&st(".sl-next").hide(),0<V&&st(".sl-prev").show(),V<$.length-1&&st(".sl-next").show()),1==$.length&&st(".sl-prev, .sl-next").hide(),1==o||-1==o){var s={opacity:1};N.animationSlide&&(B?(et(0,100*o+"px"),setTimeout(function(){et(N.animationSpeed/1e3,"0px")},50)):s.left=parseInt(st(".sl-image").css("left"))+100*o+"px"),st(".sl-image").animate(s,N.animationSpeed,function(){m=!1,y(n,t)})}else m=!1,y(n,t);N.additionalHtml&&0===st(".sl-additional-html").length&&st("<div>").html(N.additionalHtml).addClass("sl-additional-html").appendTo(st(".sl-image"))}}},y=function(t,e){""!==t&&void 0!==t&&N.captions&&x.html(t).css({width:e+"px"}).hide().appendTo(st(".sl-image")).delay(N.captionDelay).fadeIn("fast")},et=function(t,e){var a={};a[i+"transform"]="translateX("+e+")",a[i+"transition"]=i+"transform "+t+"s linear",st(".sl-image").css(a)},at=function(t,e,a){var n={};n[i+"transform"]="translate("+t+","+e+") scale("+a+")",K.css(n)},C=function(){st(ot).on("resize."+G,tt),st(".sl-wrapper").on("click."+G+" touchstart."+G,".sl-close",function(t){t.preventDefault(),U&&it()}),N.history&&setTimeout(function(){st(ot).on("hashchange."+G,function(){U&&P()===Q&&it()})},40),J.on("click."+G,"button",t(function(t){t.preventDefault(),L=0,nt(st(this).hasClass("sl-next")?1:-1)},N.throttleInterval));var e,a,n,i,s,o,l,r,c,p,h,d,u,f,g,m,v,x,b,y,C,w,T,E,S,M,I,k=0,q=0,X=0,D=0,Y=!1,A=!1,O=0,R=!1,W=Z(1,1,N.maxZoom),F=!1;_.on("touchstart."+G+" mousedown."+G,function(t){if("A"===t.target.tagName&&"touchstart"==t.type)return!0;if("mousedown"==(t=t.originalEvent).type)c=t.clientX,p=t.clientY,e=_.height(),a=_.width(),s=K.height(),o=K.width(),n=_.position().left,i=_.position().top,l=parseFloat(K.data("translate-x")),r=parseFloat(K.data("translate-y")),R=!0;else{if(I=t.touches.length,c=t.touches[0].clientX,p=t.touches[0].clientY,e=_.height(),a=_.width(),s=K.height(),o=K.width(),n=_.position().left,i=_.position().top,1===I){if(F)return K.addClass("sl-transition"),Y=Y?(z(0,0,W=1),at("0px","0px",W),!1):(W=N.doubleTapZoom,z(0,0,W),at("0px","0px",W),st(".sl-caption").fadeOut(200),!0),setTimeout(function(){K.removeClass("sl-transition")},200),!1;F=!0,setTimeout(function(){F=!1},300),l=parseFloat(K.data("translate-x")),r=parseFloat(K.data("translate-y"))}else 2===I&&(h=t.touches[1].clientX,d=t.touches[1].clientY,l=parseFloat(K.data("translate-x")),r=parseFloat(K.data("translate-y")),C=(c+h)/2,w=(p+d)/2,u=Math.sqrt((c-h)*(c-h)+(p-d)*(p-d)));R=!0}return!!A||(B&&(O=parseInt(_.css("left"))),A=!0,j=L=0,k=t.pageX||t.touches[0].pageX,X=t.pageY||t.touches[0].pageY,!1)}).on("touchmove."+G+" mousemove."+G+" MSPointerMove",function(t){if(!A)return!0;if(t.preventDefault(),"touchmove"==(t=t.originalEvent).type){if(!1===R)return!1;f=t.touches[0].clientX,g=t.touches[0].clientY,I=t.touches.length,0,1<I?(m=t.touches[1].clientX,v=t.touches[1].clientY,M=Math.sqrt((f-m)*(f-m)+(g-v)*(g-v)),null===u&&(u=M),1<=Math.abs(u-M)&&(y=Z(M/u*W,1,N.maxZoom),T=(o*y-a)/2,E=(s*y-e)/2,S=y-W,x=o*y<=a?0:Z(l-(C-n-a/2-l)/(y-S)*S,-1*T,T),b=s*y<=e?0:Z(r-(w-i-e/2-r)/(y-S)*S,-1*E,E),at(x+"px",b+"px",y),1<y&&(Y=!0,st(".sl-caption").fadeOut(200)),u=M,W=y,l=x,r=b)):(T=(o*(y=W)-a)/2,E=(s*y-e)/2,x=o*y<=a?0:Z(f-(c-l),-1*T,T),b=s*y<=e?0:Z(g-(p-r),-1*E,E),Math.abs(x)===Math.abs(T)&&(l=x,c=f),Math.abs(b)===Math.abs(E)&&(r=b,p=g),z(W,x,b),at(x+"px",b+"px",y))}if("mousemove"==t.type&&A){if("touchmove"==t.type)return!0;if(!1===R)return!1;f=t.clientX,g=t.clientY,T=(o*(y=W)-a)/2,E=(s*y-e)/2,x=o*y<=a?0:Z(f-(c-l),-1*T,T),b=s*y<=e?0:Z(g-(p-r),-1*E,E),Math.abs(x)===Math.abs(T)&&(l=x,c=f),Math.abs(b)===Math.abs(E)&&(r=b,p=g),z(W,x,b),at(x+"px",b+"px",y)}Y||(q=t.pageX||t.touches[0].pageX,D=t.pageY||t.touches[0].pageY,L=k-q,j=X-D,N.animationSlide&&(B?et(0,-L+"px"):_.css("left",O-L+"px")))}).on("touchend."+G+" mouseup."+G+" touchcancel."+G+" mouseleave."+G+" pointerup pointercancel MSPointerUp MSPointerCancel",function(t){if(t=t.originalEvent,H&&"touchend"==t.type&&(0===(I=t.touches.length)?(z(W,x,b),1==W&&(Y=!1,st(".sl-caption").fadeIn(200)),u=null,R=!1):1===I?(c=t.touches[0].clientX,p=t.touches[0].clientY):1<I&&(u=null)),A){var e=!(A=!1);N.loop||(0===V&&L<0&&(e=!1),V>=$.length-1&&0<L&&(e=!1)),Math.abs(L)>N.swipeTolerance&&e?nt(0<L?1:-1):N.animationSlide&&(B?et(N.animationSpeed/1e3,"0px"):_.animate({left:O+"px"},N.animationSpeed/2)),N.swipeClose&&50<Math.abs(j)&&Math.abs(L)<N.swipeTolerance&&it()}}).on("dblclick",function(t){return c=t.clientX,p=t.clientY,e=_.height(),a=_.width(),s=K.height(),o=K.width(),n=_.position().left,i=_.position().top,K.addClass("sl-transition"),Y?(z(0,0,W=1),at("0px","0px",W),Y=!1,st(".sl-caption").fadeIn(200)):(W=N.doubleTapZoom,z(0,0,W),at("0px","0px",W),st(".sl-caption").fadeOut(200),Y=!0),setTimeout(function(){K.removeClass("sl-transition")},200),!(R=!0)})},w=function(){var t=V+1<0?$.length-1:V+1>=$.length-1?0:V+1,e=V-1<0?$.length-1:V-1>=$.length-1?0:V-1;st("<img />").attr("src",$.eq(t).attr(N.sourceAttr)).on("load",function(){-1==d.indexOf(st(this).attr("src"))&&d.push(st(this).attr("src")),$.eq(V).trigger(st.Event("nextImageLoaded.simplelightbox"))}),st("<img />").attr("src",$.eq(e).attr(N.sourceAttr)).on("load",function(){-1==d.indexOf(st(this).attr("src"))&&d.push(st(this).attr("src")),$.eq(V).trigger(st.Event("prevImageLoaded.simplelightbox"))})},nt=function(e){$.eq(V).trigger(st.Event("change.simplelightbox")).trigger(st.Event((1===e?"next":"prev")+".simplelightbox"));var t=V+e;if(!(m||(t<0||t>=$.length)&&!1===N.loop)){V=t<0?$.length-1:t>$.length-1?0:t,st(".sl-wrapper .sl-counter .sl-current").text(V+1);var a={opacity:0};N.animationSlide&&(B?et(N.animationSpeed/1e3,-100*e-L+"px"):a.left=parseInt(st(".sl-image").css("left"))+-100*e+"px"),st(".sl-image").animate(a,N.animationSpeed,function(){setTimeout(function(){var t=$.eq(V);K.attr("src",t.attr(N.sourceAttr)),-1==d.indexOf(t.attr(N.sourceAttr))&&g.show(),st(".sl-caption").remove(),tt(e),N.preloading&&w()},100)})}},it=function(){if(!m){var t=$.eq(V),e=!1;t.trigger(st.Event("close.simplelightbox")),N.history&&(s?history.pushState("",E.title,o.pathname+o.search):o.hash="",clearTimeout(h)),st(".sl-image img, .sl-overlay, .sl-close, .sl-navigation, .sl-image .sl-caption, .sl-counter").fadeOut("fast",function(){N.disableScroll&&T("show"),N.htmlClass&&""!=N.htmlClass&&st("html").removeClass(N.htmlClass),st(".sl-wrapper, .sl-overlay").remove(),J.off("click","button"),st(".sl-wrapper").off("click."+G,".sl-close"),st(ot).off("resize."+G),st(ot).off("hashchange."+G),e||t.trigger(st.Event("closed.simplelightbox")),e=!0}),K=st(),m=U=!1}},T=function(t){var e=0;if("hide"==t){var a=ot.innerWidth;if(!a){var n=E.documentElement.getBoundingClientRect();a=n.right-Math.abs(n.left)}if(E.body.clientWidth<a){var i=E.createElement("div"),s=parseInt(st("body").css("padding-right"),10);i.className="sl-scrollbar-measure",st("body").append(i),e=i.offsetWidth-i.clientWidth,st(E.body)[0].removeChild(i),st("body").data("padding",s),0<e&&st("body").addClass("hidden-scroll").css({"padding-right":s+e})}}else st("body").removeClass("hidden-scroll").css({"padding-right":st("body").data("padding")});return e};return N.close&&r.appendTo(b),N.showCounter&&1<$.length&&(c.appendTo(b),c.find(".sl-total").text($.length)),N.nav&&J.appendTo(b),N.spinner&&g.appendTo(b),$.on("click."+G,function(t){if(function(t){if(!N.fileExt)return!0;var e=st(t).attr(N.sourceAttr).match(/\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gim);return e&&st(t).prop("tagName").toUpperCase()==n&&new RegExp(".("+N.fileExt+")$","i").test(e)}(this)){if(t.preventDefault(),m)return!1;var e=st(this);v=$.index(e),a(e)}}),st(E).on("click."+G+" touchstart."+G,function(t){U&&N.docClose&&0===st(t.target).closest(".sl-image").length&&0===st(t.target).closest(".sl-navigation").length&&it()}),N.disableRightClick&&st(E).on("contextmenu",".sl-image img",function(t){return!1}),N.enableKeyboard&&st(E).on("keyup."+G,t(function(t){L=0;var e=t.keyCode;m&&27==e&&(K.attr("src",""),m=!1,it()),U&&(t.preventDefault(),27==e&&it(),37!=e&&39!=t.keyCode||nt(39==t.keyCode?1:-1))},N.throttleInterval)),this.open=function(t){t=t||st(this[0]),v=$.index(t),a(t)},this.next=function(){nt(1)},this.prev=function(){nt(-1)},this.close=function(){it()},this.destroy=function(){st(E).off("click."+G).off("keyup."+G),it(),st(".sl-overlay, .sl-wrapper").remove(),this.off("click")},this.refresh=function(){this.destroy(),st(this).simpleLightbox(N)},this}}(jQuery,window,document);

// lightbox ( https://github.com/andreknieriem/simplelightbox )
jQuery(document).ready(function ($) {
  if ($('.js-gallery').length) {
    $('.js-gallery a').simpleLightbox({
      showCounter: false,
    });
  }
});

jQuery(document).ready(function ($) {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // události při scroolování
  $(window).on('scroll', function () {
    // rolovací menu
    rollMenu();
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav__switcher').hasClass('is-open')) {
      $('.nav, .nav__switcher').removeClass('is-open').attr('aria-expanded', 'false');
      $('.nav__switcher').text('Menu');
      $('body').removeClass('no-scroll');
    } else {
      $('.nav, .nav__switcher').addClass('is-open').attr('aria-expanded', 'true');
      $('.nav__switcher').text('Zavřít');
      $('body').addClass('no-scroll');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav, .nav__switcher').removeClass('is-open').attr('aria-expanded', 'false');
    $('.nav__switcher').text('Menu');
    $('body').removeClass('no-scroll');
  }
  // spouštěč
  $('.nav__switcher').on('click', function () {
    switchMenu();
  });
  // aria atributy k menu
  if (window.innerWidth < 992) {
    $('.nav, .nav__switcher').attr('aria-expanded', 'false');
  }

  // submenu - otevírání
  $('.nav .menu-item-has-children > a').on('click', function (e) {
    if (window.innerWidth < 992) {
      e.preventDefault();
      $(this).parent().toggleClass('is-open');
    }
  });

  // rolovací menu
  function rollMenu() {
    if ($(this).scrollTop() > 100) {
      $('.header').addClass('is-fixed');
    } else {
      $('.header').removeClass('is-fixed');
    }
  }
  rollMenu();

  // cookies - nastavení
  function setCookie_hours(name, value, hours) {
    var expires = '';

    if (hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  // cookies - vytažení
  function getCookie(name) {
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? match[1] : null;
  }

  // horní pruh
  if ($('.hey').length) {
    if (getCookie('cookie_hey') !== 'hide') {
      $('.hey').addClass('is-active');
      $('body').addClass('has-hey');
    }

    $('.hey__close').on('click', function (e) {
      e.preventDefault();
      $(this).parent().removeClass('is-active');
      setCookie_hours('cookie_hey', 'hide', 168);
    });
  }

  // FAQ - otevírání
  if ($('.faq').length) {
    $('.faq__question').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('is-open');
    });
  }

  // informační bublina - do 991px klik, od 992px hover (řešeno v CSS)
  if ($('.why__info').length) {
    $('.why__info').on('click', function (e) {
      if (window.innerWidth < 992) {
        e.preventDefault();
        $(this).toggleClass('is-open');
        $(this).next('.why__note').toggleClass('is-open');
      }
    });
  }

  // sylabus
  $('.sylabus').each(function () {
    var $sylabus = $(this);

    // otevírání (nezávisle pro každý blok)
    $sylabus.on('click', '.sylabus__lesson', function (e) {
      e.preventDefault();
      var wasOpen = $(this).hasClass('is-open');
      $sylabus.find('.sylabus__lesson').removeClass('is-open');
      if (!wasOpen) {
        $(this).addClass('is-open');
      }
    });

    // přepínání
    $sylabus.on('click', '.sylabus__subject', function (e) {
      e.preventDefault();
      var sylabusName = $(this).attr('href');
      $sylabus.find('.sylabus__subject, .sylabus__content').removeClass('is-open');
      var $content = $sylabus.find(sylabusName).addClass('is-open');
      $(this).addClass('is-open');

      // po přepnutí je vždy otevřená první lekce
      $sylabus.find('.sylabus__lesson').removeClass('is-open');
      $content.find('.sylabus__lesson').first().addClass('is-open');
    });
  });

  // webinář - otevírání
  if ($('.js-webinar-show').length) {
    $('.js-webinar-show').on('click', function (e) {
      e.preventDefault();
      $(this).next('.form').toggleClass('is-hidden');
      this.blur();
    });
  }

  // formulář - zavírání
  if ($('.js-form-hide').length) {
    $('.js-form-hide').on('click', function (e) {
      e.preventDefault();
      $(this).parent().parent().toggleClass('is-hidden');
    });
  }

  // lektoři - více hodnocení
  if ($('.js-reviews-show').length) {
    $('.js-reviews-show').on('click', function (e) {
      e.preventDefault();
      $('.review.is-hidden').removeClass('is-hidden');
      $(this).hide();
    });
  }

  // videorecenze - zobrazit všechny položky
  if ($('.js-videoreviews-show').length) {
    $('.js-videoreviews-show').on('click', function (e) {
      e.preventDefault();
      $('.videoreview.is-hidden').removeClass('is-hidden');
      $(this).hide();
    });
  }

  // záložky
  if ($('.tabs').length) {
    $('.tabs__nav a').on('click', function (e) {
      e.preventDefault();
      var tabName = $(this).attr('href');
      $('.tabs__nav a, .tabs__content').removeClass('is-active');
      $(this).addClass('is-active');
      $(tabName).addClass('is-active');
      this.blur();
    });
  }

  // lektoři - filtrace
  if ($('.js-lectors').length) {
    $('.js-lectors-switcher button').on('click', function (e) {
      e.preventDefault();
      var lectorActual = '.js-' + $(this).data('type');
      $('.js-lectors-switcher button').removeClass('is-active');
      $(this).addClass('is-active');

      if (lectorActual == '.js-vsichni') {
        $('.js-lectors .box').removeClass('is-hidden');
      } else {
        $('.js-lectors .box').addClass('is-hidden');
        $(lectorActual).removeClass('is-hidden');
      }
    });
  }

  // otevření modal okna
  if ($('.modal').length) {
    $(document).on('click', '.js-modal', function (e) {
      e.preventDefault();

      // zjištění ID okna z href atributu
      var modalName = $(this).attr('href');

      // otevření okna
      var modal = $(modalName).addClass('is-open');

      // nastavení src iframe z data atributu
      var iframe = modal.find('iframe[data-source]');
      if (iframe.length) {
        iframe.attr('src', iframe.data('source'));
      }
    });

    // zavření modal okna
    $(document).on('click', '.modal__close', function (e) {
      e.preventDefault();
      $(this).closest('.modal').removeClass('is-open').find('iframe[data-source]').attr('src', '');
    });

    // zavření okna kliknutím na pozadí
    $(document).on('click', '.modal', function (e) {
      e.preventDefault();
      $(this).removeClass('is-open').find('iframe[data-source]').attr('src', '');
    });

    // zamezení zavření po kliknutí na tělo modalu
    $(document).on('click', '.modal__body', function (e) {
      e.stopPropagation();
    });
  }

  // modal - navigace mezi videorecenzemi (předchozí/následující)
  if ($('.video-modals .modal').length > 1) {
    // vykreslení tlačítek navigace v otevřeném modalu
    var renderModalNav = function (modal) {
      modal.find('.modal__nav').remove();

      var prev = modal.prev('.modal');
      var next = modal.next('.modal');

      if (!prev.length && !next.length) {
        return;
      }

      var nav = $('<div class="modal__nav"></div>');
      if (prev.length) {
        nav.append('<button type="button" class="modal__nav-prev">Předchozí</button>');
      }
      if (next.length) {
        nav.append('<button type="button" class="modal__nav-next">Následující</button>');
      }
      modal.find('.modal__body').append(nav);
    };

    // přidání navigace při otevření modalu
    $(document).on('click', '.js-modal', function () {
      renderModalNav($($(this).attr('href')));
    });

    // přepnutí na předchozí/následující modal
    $(document).on('click', '.modal__nav-prev, .modal__nav-next', function (e) {
      e.preventDefault();

      var modal = $(this).closest('.modal');
      var target = $(this).hasClass('modal__nav-prev') ? modal.prev('.modal') : modal.next('.modal');

      if (!target.length) {
        return;
      }

      modal.removeClass('is-open').find('iframe[data-source]').attr('src', '');
      target.addClass('is-open');

      var iframe = target.find('iframe[data-source]');
      if (iframe.length) {
        iframe.attr('src', iframe.data('source'));
      }

      renderModalNav(target);
    });
  }

  // slider - recenze
  if ($('.splide--review').length) {
    $('.splide--review').each(function (index, element) {
      new Splide(element, {
        pagination: false,
        arrows: true,
        perPage: 1,
        perMove: 1,
        padding: { left: '15%', right: '15%' },
        speed: 0,
        breakpoints: {
          991: {
            padding: 0,
          },
        },
      }).mount();
    });
  }

  // slider - videorecenze
  if ($('.splide--videoreview').length) {
    $('.splide--videoreview').each(function (index, element) {
      new Splide(element, {
        pagination: false,
        arrows: true,
        perPage: 4,
        perMove: 1,
        speed: 0,
        breakpoints: {
          991: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          450: {
            perPage: 1,
          },
        },
      }).mount();
    });
  }

  // slider - články
  if ($('.splide--articles').length) {
    $('.splide--articles').each(function (index, element) {
      new Splide(element, {
        pagination: false,
        arrows: true,
        perPage: 3,
        perMove: 1,
        speed: 0,
        breakpoints: {
          991: {
            perPage: 2,
          },
          768: {
            perPage: 1,
          },
        },
      }).mount();
    });
  }

  // slider - lazy load videa
  function loadSlideVideo(slide) {
    var iframe = $(slide).find('iframe[data-src]');
    if (iframe.length && iframe.attr('src') === '') {
      iframe.attr('src', iframe.data('src'));
    }
  }
  function unloadSlideVideo(slide) {
    var iframe = $(slide).find('iframe[data-src]');
    if (iframe.length) {
      iframe.attr('src', '');
    }
  }
  function watchFirstSlideVideo(container, getSlidesFrom) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadSlideVideo($(getSlidesFrom).find('.splide__slide')[0]);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 },
    );
    observer.observe(container);
  }

  // slider - obecný / obecný s menu - přepínání mezi mobilní (akordeon) a desktopovou (Splide) verzí
  // reaguje na změnu šířky okna (např. otočení tabletu), ne jen na stav při načtení stránky
  var sliderDesktopQuery = window.matchMedia('(min-width: 1200px)');
  var generalSliders = [];
  var menuSliders = [];

  // mobilní akordeon
  function bindMobileSliderAccordion() {
    loadSlideVideo($('.splide__slide.is-open')[0]);
    $('.splide__slide h2, .splide__slide h3').on('click.sliderAccordion', function (e) {
      e.preventDefault();
      var slide = $(this).parent().parent();
      slide.toggleClass('is-open');
      if (slide.hasClass('is-open')) {
        loadSlideVideo(slide[0]);
      } else {
        unloadSlideVideo(slide[0]);
      }
    });
  }
  function unbindMobileSliderAccordion() {
    $('.splide__slide h2, .splide__slide h3').off('click.sliderAccordion');
  }

  // slider - obecný
  function mountGeneralSliders() {
    $('.splide--slider').each(function (index, element) {
      var splide = new Splide(element, {
        pagination: false,
        arrows: true,
        perPage: 1,
        perMove: 1,
        speed: 0,
      });
      splide.on('move', function (newIndex, prevIndex) {
        $(element)
          .find('.slider__current')
          .text(newIndex + 1);
        var slides = $(element).find('.splide__slide');
        loadSlideVideo(slides[newIndex]);
        unloadSlideVideo(slides[prevIndex]);
      });
      splide.mount();
      watchFirstSlideVideo(element, element);
      generalSliders.push(splide);
    });
  }

  // slider - obecný s menu
  function mountMenuSliders() {
    $('.slider-menu').each(function () {
      var thisSlider = $(this).find('.splide--slider-menu')[0];
      var thisMenu = $(this).find('.splide--menu')[0];

      var splideSlider = new Splide(thisSlider, {
        pagination: false,
        arrows: true,
        perPage: 1,
        perMove: 1,
        speed: 0,
      });

      var splideMenu = new Splide(thisMenu, {
        pagination: false,
        arrows: false,
        autoWidth: true,
        perMove: 1,
        speed: 0,
        isNavigation: true,
      });

      splideSlider.on('move', function (newIndex, prevIndex) {
        $(thisSlider)
          .find('.slider__current')
          .text(newIndex + 1);
        var slides = $(thisSlider).find('.splide__slide');
        loadSlideVideo(slides[newIndex]);
        unloadSlideVideo(slides[prevIndex]);
      });

      splideSlider.sync(splideMenu);
      splideSlider.mount();
      splideMenu.mount();
      watchFirstSlideVideo(thisSlider, thisSlider);

      menuSliders.push(splideSlider, splideMenu);
    });
  }

  // přepnutí dle aktuální šířky
  function switchSliders(isDesktop) {
    if (isDesktop) {
      unbindMobileSliderAccordion();
      if ($('.splide--slider').length) {
        mountGeneralSliders();
      }
      if ($('.slider-menu').length) {
        mountMenuSliders();
      }
    } else {
      generalSliders.concat(menuSliders).forEach(function (splide) {
        splide.destroy();
      });
      generalSliders = [];
      menuSliders = [];
      if ($('.splide__slide').length) {
        bindMobileSliderAccordion();
      }
    }
  }
  switchSliders(sliderDesktopQuery.matches);
  sliderDesktopQuery.addEventListener('change', function (e) {
    switchSliders(e.matches);
  });

  // videa mimo slider - lazy load při vstupu do viewportu
  var standaloneIframes = $('iframe[data-src]').not('.splide *');
  if (standaloneIframes.length) {
    standaloneIframes.each(function () {
      var iframe = this;
      var iframeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              iframe.src = iframe.dataset.src;
              iframeObserver.unobserve(iframe);
            }
          });
        },
        { threshold: 0.1 },
      );
      iframeObserver.observe(iframe);
    });
  }

  // Supportbox - lazy load po kliknutí na .supportbox
  if ($('.supportbox').length) {
    var supportboxLoaded = false;
    $('.supportbox').on('click', function () {
      if (supportboxLoaded) return;
      supportboxLoaded = true;
      var script = $('script[data-src*="supportbox"]');
      if (!script.length) return;
      $(window).one('supportBox:api:initialized', function () {
        window.supportBoxApi.open();
        $('.supportbox').hide();
      });
      script[0].src = script.data('src');
    });
  }

  // Trustindex - přidání hodnocení
  function trustindexRanking() {
    if ($('.star-lg').length) {
      var el = $('.star-lg');
      var span = $('<strong class="section__ranking">' + rankingGoogle + '</strong>');
      el.prepend(span);
    } else {
      setTimeout(trustindexRanking, 1000);
    }
  }
  if (rankingGoogle.length) {
    $(function () {
      setTimeout(trustindexRanking, 1000);
    });
  }
});

//# sourceMappingURL=scripts.js.map
